export default {
  getPrompt: (state) => state.prompt,
};
